export default {
  failed: 0,
  success: 1,
  pending: 2,
  instructions: 9,
  pincode: 2,
};
